import React, { useState } from "react";
import {
  Grid,
  Typography,
  TextField,
  FormControlLabel,
  Checkbox,
  Stack,
  Paper,
  Box,
} from "@mui/material";
import CustomButton from "../CustomButton";
import AreaSelector from "../AreaSelector";
import { toast } from "react-toastify";
import { updateVehicleConfigAPI } from "../../apis/metrics.apis";
const vehicleTypes = ["2-wheeler", "3-wheeler", "4-wheeler", "Bus"];

const ChangeTypeImpressionStatus = () => {
  const [selectedArea, setSelectedArea] = useState({});
  const [vehicleData, setVehicleData] = useState(
    vehicleTypes.map((type) => ({
      type,
      length: "",
      multiplier: "",
      allowed: true,
      selected: false,
      composition: "",
    }))
  );

  const handleChange = (index, field, value) => {
    const updated = [...vehicleData];
    updated[index][field] = value;
    setVehicleData(updated);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !selectedArea?.zone?.id ||
      !selectedArea?.state?.id ||
      !selectedArea?.city?.id
    ) {
      toast.error("Please select Zone, State, and City.");
      return;
    }

    const selectedEntries = vehicleData.filter((v) => v.selected);
    if (selectedEntries.length === 0) {
      toast.error("Select at least one vehicle type to update.");
      return;
    }

    const payload = {
      city_id: selectedArea.city.id,
      entries: selectedEntries.map((entry) => ({
        type: entry.type,
        length: entry.length !== "" ? parseFloat(entry.length) : null,
        multiplier:
          entry.multiplier !== "" ? parseFloat(entry.multiplier) : null,
        allowed: entry.allowed,
        composition:
          entry.composition !== "" ? parseFloat(entry.composition) : null
      })),
    };

    try {
      console.log("Submitting payload:", payload);
      setVehicleData(
        vehicleTypes.map((type) => ({
          type,
          length: "",
          multiplier: "",
          allowed: true,
          selected: false,
          composition: "",
        }))
      );
      await updateVehicleConfigAPI(payload);

      toast.success("Vehicle config updated!");
    } catch (error) {
      toast.error("Submission failed!");
    }
  };
  return (
    <form onSubmit={handleSubmit}>
      <Typography variant="h6" mb={2}>
        Market Selection
      </Typography>

      <Grid container spacing={3} mb={3}>
        <Grid item xs={12} sm={6} md={4}>
          <AreaSelector onChange={(val) => setSelectedArea(val)} />
        </Grid>
      </Grid>

      <Paper elevation={2} sx={{ p: 2 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={2}>
            <Typography fontWeight="bold">Vehicle Type</Typography>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography fontWeight="bold">Length</Typography>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography fontWeight="bold">Multiplier</Typography>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography fontWeight="bold">Composition (%)</Typography>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography fontWeight="bold">Allowed</Typography>
          </Grid>
        </Grid>

        {vehicleData.map((vehicle, index) => (
          <Grid
            container
            spacing={2}
            alignItems="center"
            key={vehicle.type}
            mt={1}
          >
            <Grid item xs={12} sm={2}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={vehicle.selected}
                    onChange={(e) =>
                      handleChange(index, "selected", e.target.checked)
                    }
                  />
                }
                label={vehicle.type}
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <TextField
                label="Length"
                type="number"
                fullWidth
                value={vehicle.length}
                onChange={(e) => handleChange(index, "length", e.target.value)}
                disabled={!vehicle.selected}
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <TextField
                label="Multiplier"
                type="number"
                fullWidth
                value={vehicle.multiplier}
                onChange={(e) =>
                  handleChange(index, "multiplier", e.target.value)
                }
                disabled={!vehicle.selected}
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <TextField
                label="Composition (%)"
                type="number"
                fullWidth
                value={vehicle.composition}
                onChange={(e) =>
                  handleChange(index, "composition", e.target.value)
                }
                disabled={!vehicle.selected}
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <Checkbox
                checked={vehicle.allowed}
                onChange={(e) =>
                  handleChange(index, "allowed", e.target.checked)
                }
                disabled={!vehicle.selected}
              />
            </Grid>
          </Grid>
        ))}
      </Paper>

      <Stack mt={4} direction="row" justifyContent="center">
        <CustomButton type="submit" sx={{ minWidth: "200px" }}>
          Submit
        </CustomButton>
      </Stack>
    </form>
  );
};

export default ChangeTypeImpressionStatus;

// CREATE TABLE city_vehicle_config (
//   id SERIAL PRIMARY KEY,
//   city_id INTEGER REFERENCES cities(city_id) ON DELETE CASCADE,
//   vehicle_type VARCHAR(20) NOT NULL,
//   vehicle_length FLOAT,
//   multiplier FLOAT,
//   allowed BOOLEAN DEFAULT TRUE,
//   UNIQUE (city_id, vehicle_type)
// );

// INSERT INTO city_vehicle_config (city_id, vehicle_type, vehicle_length, multiplier, allowed)
// SELECT c.city_id, v.vehicle_type, v.vehicle_length, v.multiplier, TRUE
// FROM cities c
// JOIN (
//     SELECT '2-wheeler' AS vehicle_type, 2.4 AS vehicle_length, 1.2 AS multiplier
//     UNION ALL
//     SELECT '3-wheeler', 3.0, 1.5
//     UNION ALL
//     SELECT '4-wheeler', 5.0, 2.8
//     UNION ALL
//     SELECT 'Bus', 12.0, 25.0
// ) AS v;

// ALTER TABLE city_vehicle_config
// ADD COLUMN composition FLOAT DEFAULT 0.0,
// ADD COLUMN lane_1 FLOAT DEFAULT 0.0,
// ADD COLUMN lane_2 FLOAT DEFAULT 0.0,
// ADD COLUMN lane_3 FLOAT DEFAULT 0.0,
// ADD COLUMN lane_4 FLOAT DEFAULT 0.0,
// ADD COLUMN lane_5 FLOAT DEFAULT 0.0,
// ADD COLUMN lane_6 FLOAT DEFAULT 0.0,
// ADD COLUMN lane_7 FLOAT DEFAULT 0.0;

// CREATE TABLE video_vehicle_config (
//     id INT AUTO_INCREMENT PRIMARY KEY,
//     video_id VARCHAR(255) NOT NULL,
//     vehicle_type VARCHAR(50) NOT NULL,   -- e.g., '2-wheeler', '3-wheeler'
//     allowed BOOLEAN NOT NULL DEFAULT TRUE,
//     FOREIGN KEY (video_id) REFERENCES videofiles(video_id)
// );
